import { t } from 'i18next';
import { permissionLevelEnum } from '../enums';

export const permissionLevelLabels: Record<number, string> = {
    [permissionLevelEnum.ADMIN]: 'admin',
    [permissionLevelEnum.SUPERVISION]: 'supervision',
    [permissionLevelEnum.PLANNING]: 'planning',
    [permissionLevelEnum.CONDUC]: 'conduc',
    [permissionLevelEnum.OBSERVERS]: 'observers',
    [permissionLevelEnum.CHAUFFEUR]: 'driver',
    [permissionLevelEnum.TERRAIN]: 'field',
};

export const getPermissionLevelLabel = (level?: number): string => {
    return level !== undefined && permissionLevelLabels[level] ? t(permissionLevelLabels[level]) : '';
};
